import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  SucursalService,
  UsuarioService,
} from 'src/app/administracion/servicios';
import { TipoServicio } from 'src/app/administracion/modelos/Control_Usuario/tipo-servicio';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { ServicioUsuario } from 'src/app/administracion/modelos/Control_Usuario/servicio-usuario';
import Swal from 'sweetalert2';
import { TipoServicioService } from 'src/app/administracion/servicios/Control_Usuario/tipo-servicio.service';
import { SolicitudService } from 'src/app/administracion/servicios/Control_Usuario/solicitud.service';
import { DetalleSolicitudService } from 'src/app/administracion/servicios/Control_Usuario/detalle-solicitud.service';
import { ServicioUsuarioService } from 'src/app/administracion/servicios/Control_Usuario/servicio-usuario.service';
import { DetalleSolicitud } from 'src/app/administracion/modelos/Control_Usuario/detalle-solicitud';
import { Empleado } from 'src/app/administracion/modelos/empleado';
import { Sucursal } from 'src/app/administracion/modelos/sucursal';
import { ElemServicioService } from 'src/app/administracion/servicios/Control_Usuario/elem-servicio.service';
import { combineLatest, forkJoin, Observable, of } from 'rxjs';
import { regexEmail } from 'src/app/constants/regex-email';
import { EdicionServicioModel } from './edicion-servicio.model';
import { map, switchMap, take } from 'rxjs/operators';
import { SwalService } from 'src/app/administracion/servicios/swal.service';

@Component({
  selector: 'app-detalle-alta',
  templateUrl: './detalle-alta.component.html',
  styleUrls: ['./detalle-alta.component.scss'],
})
export class DetalleAltaComponent implements OnInit {
  dataSource: ServicioUsuario[] = [];
  dataSourceEdicion: EdicionServicioModel[] = [];
  dataAtendidos = new MatTableDataSource<DetalleSolicitud>([]);
  dataSourceServiciosSucursalesAlta = new MatTableDataSource<ServicioUsuario>(
    []
  );
  /**Listas utilizadas */
  listaServicios: TipoServicio[] = [];
  listaTiposServiciosGeneral: TipoServicio[] = [];
  serviciosAdd: TipoServicio[] = [];
  listaSucursales: Sucursal[] = [];

  /**Encabezados de la tabla */
  encabezadostabla: String[] = ['c1', 'c2', 'c3', 'c4', 'c5', 'c6'];
  encabezadostabla4: String[] = ['c1', 'c2', 'c3', 'c4'];
  encabezadostabAtendidos: String[] = ['c1', 'c2'];

  cabeceraCheck: String = '';
  colaborador: Empleado = new Empleado();

  tipo: string = '';
  tipoSolicitud: string = 'ALTA DE SERVICIOS';
  statusSolicitud: string = '';
  banderaExpediente: string = '';

  editandoCredenciales = false;
  cargandoActualizacion = false;

  idSolicitud: number = 0;

  /**Campos de la solicitud realizada */
  formDetSolicitud = this.formBuilder.group({
    colaborador: [''],
    solicitante: [''],
    tipoSolicitud: [''],
    fecha_planeada: [''],
    sustituye_a: [''],
    supervisor: [''],
    comentarios: [''],
    puesto: [''],
    sucursal: [''],
    puesto_solicitante: [''],
    sucursal_solicitante: [''],
    email_solicitante: [''],
    tipo_servicio: ['', []],
    tipo_servicio2: ['', []],
    nom_usuario: ['', []],
    contrasenia: ['', []],
  });

  cargando = false;

  constructor(
    private readonly router: Router,
    private readonly usuarioService: UsuarioService,
    private readonly tipoServicioService: TipoServicioService,
    private readonly solicitudService: SolicitudService,
    private readonly detalleSolicitudService: DetalleSolicitudService,
    private readonly servicioUsuarioService: ServicioUsuarioService,
    private readonly elemServicioService: ElemServicioService,
    private readonly sucursalService: SucursalService,
    private readonly formBuilder: FormBuilder,
    private readonly activeRouter: ActivatedRoute,
    private readonly swalService: SwalService
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.sucursalService.getSucursales(),
      this.tipoServicioService.todosLosServicios(),
      this.activeRouter.params,
    ])
      .pipe(take(1))
      .subscribe({
        next: ([sucursales, tipoServicios, params]) => {
          // params
          this.idSolicitud = params['idSolicitud'];
          this.banderaExpediente = params['banderaE'] + '';

          // sucursales
          this.listaSucursales = sucursales;

          // tipo de servicios
          this.listaTiposServiciosGeneral = tipoServicios.filter(
            (tipoServicio) => tipoServicio.status_servicio == 'ACTIVO'
          );

          this.cargarDatosSolicitud();
          this.obtenerDetallesSolicitud();
        },
      });
  }

  cargarDatosSolicitud() {
    this.solicitudService.unaSolicitud(this.idSolicitud).subscribe((val) => {
      this.tipo = val.tipo + '';
      this.statusSolicitud = val.status_solicitud + '';
      this.tipoSolicitud = val?.tipo_solicitud_usuario?.tipo_solicitud + '';
      //Datos del colaborador
      this.formDetSolicitud.controls['tipoSolicitud'].setValue(
        val?.tipo_solicitud_usuario?.tipo_solicitud
      );
      this.usuarioService
        .getAnEmpleado(Number(val.colaboradorId))
        .pipe(
          switchMap((empleado) => {
            if (val.puestoColaboradorId) {
              return this.usuarioService
                .getAnPuesto(Number(val.puestoColaboradorId))
                .pipe(
                  map((puesto) => {
                    const nuevoEmpleado = JSON.parse(JSON.stringify(empleado));
                    nuevoEmpleado.puesto = puesto;
                    return nuevoEmpleado;
                  })
                );
            }

            return of(empleado);
          })
        )
        .subscribe((valor) => {
          this.formDetSolicitud.controls['colaborador'].setValue(
            valor?.nombre + ' ' + valor?.apellidoPat + ' ' + valor?.apellidoMat
          );
          this.formDetSolicitud.controls['puesto'].setValue(
            valor?.puesto?.nombrePuesto
          );
          this.formDetSolicitud.controls['sucursal'].setValue(
            valor?.sucursal?.nombreSucursal
          );
          this.colaborador = valor;
        });
      //Datos del solicitante
      this.usuarioService
        .getAnEmpleado(Number(val.solicitanteId))
        .subscribe((valor) => {
          this.formDetSolicitud.controls['solicitante'].setValue(
            valor?.nombre + ' ' + valor?.apellidoPat + ' ' + valor?.apellidoMat
          );
          this.formDetSolicitud.controls['puesto_solicitante'].setValue(
            valor?.puesto?.nombrePuesto
          );
          this.formDetSolicitud.controls['sucursal_solicitante'].setValue(
            valor?.sucursal?.nombreSucursal
          );
          this.formDetSolicitud.controls['email_solicitante'].setValue(
            valor?.correoInstitucional
          );
        });

      this.formDetSolicitud.controls['sustituye_a'].setValue(val?.sustituye_a);
      this.formDetSolicitud.controls['supervisor'].setValue(
        val?.nom_supervisor
      );

      this.formDetSolicitud.controls['comentarios'].setValue(val?.comentarios);
      this.formDetSolicitud.controls['fecha_planeada'].setValue(
        val?.fecha_planeada_act?.substring(0, 10)
      );
      // this.llenarTablaAtendidos(this.idSolicitud);
      // this.llenarTablaServAlta();

      //Ejecutar metodo para llenar la tabla segun se necesite
      this.cabeceraCheck = 'APROBAR ';
      // this.llenarTablaServicios();
    });
  }

  /**Llena las listas de sucursales y servicios */
  private obtenerDetallesSolicitud() {
    this.cargando = true;
    this.listaServicios = [];

    this.detalleSolicitudService
      .listaDetSolicitudPorSolicitudId(this.idSolicitud)
      .subscribe(
        (detallesSolicitud) => {
          // llenar las tablas de servicios aprobados
          this.dataSource = [];
          this.dataSourceEdicion = [];
          this.dataAtendidos.data = [];
          this.cargando = false;

          this.procesarDetallesSolicitud(detallesSolicitud);

          this.llenarTablaServAlta();
        },
        (error) => {
          this.cargando = false;
          this.swalService.operacionFallida(
            'Error al obtener detalles de la solicitud'
          );
        }
      );
  }

  procesarDetallesSolicitud(detallesSolicitud: DetalleSolicitud[]) {
    // filtrar lista de servicios que están disponibles para asignar
    this.listaServicios = this.listaTiposServiciosGeneral.filter(
      (e) =>
        !detallesSolicitud.some(
          (d) => d.tipo_servicio.id_tipo_servicio === e.id_tipo_servicio
        )
    );

    const listaServicioUsuario = detallesSolicitud.map((element) => {
      let regUsuario: ServicioUsuario = new ServicioUsuario();
      /**Expresion regular en caso de ser gmail */
      if (element.tipo_servicio.nombre_servicio?.includes('GMAIL')) {
        /**Valida que el correo ingresado sea válido */
        regUsuario.expresionRegular =
          "^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$";
      } else {
        regUsuario.expresionRegular = '';
      }

      regUsuario.detalleSolicitud = element;
      regUsuario.nombre_servicio = element.tipo_servicio.nombre_servicio;
      regUsuario.status_serv = element.status_serv;
      regUsuario.detalle_solicitud_id = element.id_detalle_solicitud;

      return regUsuario;
    });

    this.dataSource = [...this.dataSource, ...listaServicioUsuario];

    this.dataSourceEdicion = [
      ...this.dataSourceEdicion,
      ...detallesSolicitud.map((e) => {
        const edicionServicio: EdicionServicioModel = {
          detalle_solicitud_id: e.id_detalle_solicitud!,
          nombre_servicio: e.tipo_servicio.nombre_servicio,
          sucursales: [],
          recienAgregado: e.id_detalle_solicitud === null,
          id_tipo_servicio: null,
          eliminar: false,
        };
        return edicionServicio;
      }),
    ];

    /**Llena la tabla al momento de mostrar una solicitud atendida */
    const listaDetSolicitudes = detallesSolicitud.map((element) => {
      let detSolicitud: DetalleSolicitud = new DetalleSolicitud();
      detSolicitud.nombre_servicio = element.tipo_servicio.nombre_servicio;
      detSolicitud.status_serv = element.status_serv;
      return detSolicitud;
    });
    this.dataAtendidos.data = [
      ...this.dataAtendidos.data,
      ...listaDetSolicitudes,
    ];
  }

  //Método para generar el detalle de la solicitud
  agregarServicioAlta() {
    this.cargando = true;

    /**Corresponde a una solicitud de alta de servicios o cualquier otra que no sea de activacion o suspensión */
    this.serviciosAdd = this.formDetSolicitud.value.tipo_servicio;
    const serviciosAddObservables: Observable<DetalleSolicitud>[] = [];

    this.serviciosAdd.forEach((val) => {
      serviciosAddObservables.push(
        this.detalleSolicitudService.generarDetalleSolicitud(
          this.idSolicitud,
          Number(val.id_tipo_servicio),
          0
        )
      );
    });

    forkJoin(serviciosAddObservables).subscribe(
      (resp) => {
        this.cargando = false;
        this.procesarDetallesSolicitud(resp);
      },
      (error) => {
        this.cargando = false;
        this.swalService.operacionFallida('Error al agregar servicios');
      }
    );

    this.formDetSolicitud.controls['tipo_servicio'].setValue([]);
  }

  generarDetalleSolicitudEdicion() {
    /**Corresponde a una solicitud de alta de servicios o cualquier otra que no sea de activacion o suspensión */
    this.serviciosAdd = this.formDetSolicitud.value.tipo_servicio;
    const serviciosAddObservables: Observable<DetalleSolicitud>[] = [];

    this.serviciosAdd.forEach((val) => {
      serviciosAddObservables.push(
        this.detalleSolicitudService.generarDetalleSolicitudAtendido(
          this.idSolicitud,
          Number(val.id_tipo_servicio),
          0
        )
      );
    });

    forkJoin(serviciosAddObservables).subscribe(
      (response) => {
        //this.obtenerDetallesSolicitud();
        const nuevoDatasourceEdicion = [...this.dataSourceEdicion];
        nuevoDatasourceEdicion.push(
          ...response.map((e) => {
            const edicionServicio: EdicionServicioModel = {
              detalle_solicitud_id: e.id_detalle_solicitud!,
              nombre_servicio: e.tipo_servicio.nombre_servicio,
              sucursales: [],
              recienAgregado: e.id_detalle_solicitud !== null,
              id_tipo_servicio: null,
              eliminar: false,
            };
            return edicionServicio;
          })
        );
        this.cargando = false;
        this.dataSourceEdicion = nuevoDatasourceEdicion;
        this.swalService.operacionExitosa('Servicios agregados correctamente');
      },
      (error) => {
        this.cargando = false;
        this.swalService.operacionFallida('Error al agregar servicios');
      }
    );

    this.formDetSolicitud.controls['tipo_servicio'].setValue([]);
  }

  agregarNuevosServiciosEdicion() {
    this.serviciosAdd = this.formDetSolicitud.value.tipo_servicio;

    if (this.serviciosAdd.length === 0) {
      return;
    }

    this.dataSourceEdicion = [
      ...this.dataSourceEdicion,
      ...this.serviciosAdd.map((e) => {
        return {
          detalle_solicitud_id: null,
          nombre_servicio: e.nombre_servicio!,
          sucursales: [],
          recienAgregado: true,
          id_tipo_servicio: e.id_tipo_servicio!,
          eliminar: false,
        };
      }),
    ];

    this.formDetSolicitud.controls['tipo_servicio'].setValue([]);
  }

  /**Llena la tabla al momento de mostrar una solicitud atendida con las credenciales de los servicios que se le fueron otorgadas */
  llenarTablaServAlta() {
    let listaServicioUsuario: ServicioUsuario[] = [];
    const listaServiciosUsuarioEdicion: EdicionServicioModel[] = [
      ...this.dataSourceEdicion,
    ];

    this.cargando = true;

    this.elemServicioService
      .listaElemServicioIdSolicitudAct(this.idSolicitud)
      .subscribe(
        (elementos) => {
          elementos.forEach((elem) => {
            const index = listaServiciosUsuarioEdicion.findIndex(
              (e) =>
                e.detalle_solicitud_id ===
                elem.servicio_usuario.detalleSolicitud?.id_detalle_solicitud
            );

            if (index > -1) {
              listaServiciosUsuarioEdicion[index].usuario =
                elem.servicio_usuario.usuario;
              listaServiciosUsuarioEdicion[index].contrasenia =
                elem.servicio_usuario.contrasenia;
              listaServiciosUsuarioEdicion[index].id_servicio_usuario =
                elem.servicio_usuario.id_servicio_usuario;
            }

            if (elem.detalle_solicitudAct.status_serv == 'Aceptado') {
              let servicioU: ServicioUsuario = new ServicioUsuario();
              servicioU = elem.servicio_usuario;

              this.sucursalService
                .getAnSucursal(Number(elem.sucursal_id))
                .subscribe((sucursal) => {
                  servicioU.nomSucursalCol = sucursal.nombreSucursal;

                  const servicioEdicion = listaServiciosUsuarioEdicion.find(
                    (s) =>
                      s.id_servicio_usuario === servicioU.id_servicio_usuario
                  );

                  if (servicioEdicion) {
                    servicioEdicion.sucursales.push(sucursal);
                  }
                });

              listaServicioUsuario.push(servicioU);
            }
          });

          this.dataSourceServiciosSucursalesAlta.data = listaServicioUsuario;
          this.dataSourceEdicion = listaServiciosUsuarioEdicion;
          this.cargando = false;
        },
        (error) => {
          this.cargando = false;
          this.swalService.operacionFallida(
            'Error al obtener elementos de servicio'
          );
        }
      );
  }

  /**Método para rechazar una solicitud y todos sus servicios */
  async rechazarSolicitud() {
    const result = await Swal.fire({
      title: '¿Está seguro de que desea rechazar esta solicitud?',
      text: '¡Ya no podrá revertir esta acción!',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, rechazar solicitud',
    });

    if (!result.isConfirmed) {
      return;
    }

    const { value: text } = await Swal.fire({
      title: 'Razón por la cual rechaza la solicitud: ',
      input: 'text',
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Aceptar',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
    });

    if (!text) {
      await Swal.fire({
        title:
          'No se rechazó la solicitud, es necesario insertar un motivo por el cual se desea rechazar.',
        icon: 'warning',
        timer: 3000,
        showConfirmButton: false,
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
      });
      return;
    }

    /**valida que se haya ingresado una razón */

    let comentarios = 'Motivo del rechazo de la solicitud: ' + text;
    //Editamos el status de la solicitud
    this.solicitudService.actualizarStatusSolicitud(
      this.idSolicitud,
      'Atendido',
      comentarios
    );
    //Se edita el status de los detalles de la solicitud
    this.detalleSolicitudService
      .listaDetSolicitudPorSolicitudId(this.idSolicitud)
      .subscribe((valor) => {
        valor.forEach((element) => {
          this.detalleSolicitudService.actualizarStatusDetSolicitud(
            Number(element.id_detalle_solicitud),
            'Rechazado'
          );
        });
      });

    //mensaje  de confirmación
    Swal.fire(
      '¡Solicitud rechazada!',
      'La solicitud ha sido rechazada',
      'success'
    );

    this.router.navigate([
      'layout/gestionSolicitudesAdmin/' + this.tipoSolicitud,
    ]);
  }

  /**Agrega los servicios que fueron solicitados y aprobados */
  agregarServicio() {
    if (this.dataSource.length == 0) {
      Swal.fire({
        icon: 'info',
        title: 'No ha seleccionado ningun servicio',
        text: 'Debe seleccionar el o los servicios que desea aprobar',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    // validar que todos los servicios tengan sucursales seleccionadas y credenciales
    let message = '';
    const serviciosConErrores = this.dataSource.some((e) => {
      // validar que todos los servicios tengan sucursales seleccionadas
      if (e.sucursales.length === 0) {
        message =
          'Debe seleccionar al menos una sucursal de cada servicio aprobado';
        return true;
      }

      // validar que todos los servicios tengan usuario y contraseña
      if (
        !e.usuario ||
        !e.contrasenia ||
        e.usuario.trim() === '' ||
        e.contrasenia.trim() === ''
      ) {
        message =
          'Es necesario que le asigne "Usuario" y "Contraseña" a todos los servicios aprobados';
        return true;
      }
      return false;
    });

    // validar que todos los servicios tengan sucursales seleccionadas
    if (serviciosConErrores) {
      Swal.fire({
        icon: 'info',
        title: 'Faltan campos',
        text: message,
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    // validar que si el servicio es gmail, el usuario sea un correo electrónico válido
    const servicioGmail = this.dataSource.find((e) =>
      e.detalleSolicitud.tipo_servicio.nombre_servicio?.includes('GMAIL')
    );
    if (servicioGmail) {
      if (!regexEmail.test(servicioGmail.usuario!)) {
        Swal.fire({
          icon: 'info',
          title: 'Correo electrónico inválido',
          text: 'El valor ingresado en GMAIL no es válido. Porfavor ingrese el dato con formato de correo correcto.',
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
    }

    //guardar

    //Editamos el status de la solicitud
    this.solicitudService.actualizarStatusSolicitud(
      this.idSolicitud,
      'Atendido',
      ''
    );

    const arrayObservables: Observable<any>[] = [];

    //Se crea un registro de servicio usuario
    this.dataSource.forEach((val) => {
      let usuario = val.usuario + '';
      let contrasenia = val.contrasenia + '';
      let id_detalle = Number(val.detalle_solicitud_id);
      this.detalleSolicitudService.actualizarStatusDetSolicitud(
        Number(val.detalle_solicitud_id),
        'Aceptado'
      );
      //se insertaba un status de alta
      arrayObservables.push(
        this.servicioUsuarioService
          .guardarServicioUsuario(usuario, contrasenia, id_detalle)
          .pipe(
            switchMap((servicioU) => {
              return this.elemServicioService.agregarElemServicio(
                Number(servicioU.id_servicio_usuario),
                Number(val.detalle_solicitud_id),
                Number(val.sucursales[0].idSucursal)
              );
            })
          )
      );
    });

    forkJoin(arrayObservables).subscribe(
      () => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Solicitud aprobada',
          text: ' Los servicios fueron registrados y dados de alta correctamente',
        });
        this.router.navigate([
          'layout/gestionSolicitudesAdmin/' + this.tipoSolicitud,
        ]);
      },
      (err) => {
        console.error(err);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al aprobar solicitud',
          text: 'Ocurrió un error al aprobar la solicitud',
        });
      }
    );
  }

  /**Leé las sucursales  y retorna una lista de sucursales separadas por un - */
  leerSucursales(sucursales: Sucursal[]): string {
    let nomSucursales = '';
    sucursales.forEach((sucursal) => {
      nomSucursales = nomSucursales + sucursal.nombreSucursal + ' - ';
    });
    return nomSucursales;
  }

  /**salida */
  goBack() {
    if (this.banderaExpediente == 'true') {
      this.router.navigate([
        'layout/Expedientes2/' + this.colaborador.idEmpleado,
      ]);
    } else {
      this.router.navigate([
        'layout/gestionSolicitudesAdmin/' + this.tipoSolicitud,
      ]);
    }
  }

  toggleEditar() {
    this.editandoCredenciales = !this.editandoCredenciales;
  }

  cancelarEdicion() {
    this.formDetSolicitud.controls['tipo_servicio'].setValue([]);
    this.toggleEditar();
    this.obtenerDetallesSolicitud();
  }

  guardarEdicion() {
    if (this.dataSourceEdicion.length == 0) {
      return;
    }

    // validar que todos los servicios tengan sucursales seleccionadas y credenciales
    let message = '';
    const serviciosConErrores = this.dataSourceEdicion.some((e) => {
      // validar que todos los servicios tengan sucursales seleccionadas
      if (e.sucursales.length === 0) {
        message =
          'Debe seleccionar al menos una sucursal de cada servicio aprobado';
        return true;
      }

      // validar que todos los servicios tengan usuario y contraseña
      if (
        !e.usuario ||
        !e.contrasenia ||
        e.usuario.trim() === '' ||
        e.contrasenia.trim() === ''
      ) {
        message =
          'Es necesario que le asigne "Usuario" y "Contraseña" a todos los servicios aprobados';
        return true;
      }
      return false;
    });

    // validar que todos los servicios tengan sucursales seleccionadas
    if (serviciosConErrores) {
      Swal.fire({
        icon: 'info',
        title: 'Faltan campos',
        text: message,
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    // validar que si el servicio es gmail, el usuario sea un correo electrónico válido
    const servicioGmail = this.dataSourceEdicion.find((e) =>
      e.nombre_servicio?.includes('GMAIL')
    );
    if (servicioGmail) {
      if (!regexEmail.test(servicioGmail.usuario!)) {
        Swal.fire({
          icon: 'info',
          title: 'Correo electrónico inválido',
          text: 'El valor ingresado en GMAIL no es válido. Porfavor ingrese el dato con formato de correo correcto.',
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
    }

    const arrayObservables: Observable<any>[] = [];

    const elementosEliminar = this.dataSourceEdicion.filter((e) => e.eliminar);

    if (elementosEliminar.length) {
      elementosEliminar.forEach((element) => {
        arrayObservables.push(
          this.detalleSolicitudService.eliminarDetalleSolicitud(
            element.detalle_solicitud_id!
          )
        );
      });

      this.dataSourceEdicion = [
        ...this.dataSourceEdicion.filter((e) => !e.eliminar),
      ];

      forkJoin(arrayObservables).subscribe(() => {
        this.guardarEdicion();
        return;
      });

      return;
    }

    // agregar servicios nuevos
    this.dataSourceEdicion
      .filter((e) => e.recienAgregado && !e.id_servicio_usuario)
      .forEach((val) => {
        let usuario = val.usuario + '';
        let contrasenia = val.contrasenia + '';

        arrayObservables.push(
          this.detalleSolicitudService
            .generarDetalleSolicitudAtendido(
              this.idSolicitud,
              Number(val.id_tipo_servicio),
              0
            )
            .pipe(
              switchMap((detalle) =>
                this.servicioUsuarioService
                  .guardarServicioUsuario(
                    usuario,
                    contrasenia,
                    detalle.id_detalle_solicitud!
                  )
                  .pipe(
                    switchMap((servicioU) =>
                      forkJoin(
                        val.sucursales.map((sucursalSelect) =>
                          this.elemServicioService.agregarElemServicio(
                            Number(servicioU.id_servicio_usuario),
                            Number(detalle.id_detalle_solicitud),
                            Number(sucursalSelect.idSucursal)
                          )
                        )
                      )
                    )
                  )
              )
            )
        );
      });

    // actualizar servicios existentes con nuevas sucursales
    const dto = this.dataSourceEdicion
      .filter((e) => !e.recienAgregado && e.id_servicio_usuario)
      .map((e) => {
        const sucursales = [...e.sucursales];
        return {
          ...e,
          sucursales: sucursales.map((s) => s.idSucursal),
        };
      });
    if (dto.length) {
      arrayObservables.push(
        this.servicioUsuarioService.actualizarCredencialesServiciosUsuario(dto)
      );
    }

    this.cargandoActualizacion = true;
    this.cargando = true;

    forkJoin(arrayObservables).subscribe(
      () => {
        this.editandoCredenciales = false;
        this.cargando = false;
        this.cargandoActualizacion = false;
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Credenciales actualizadas',
          text: 'Las credenciales han sido actualizadas correctamente',
        });
        this.obtenerDetallesSolicitud();
      },
      (err) => {
        console.error(err);
        this.cargando = false;
        this.cargandoActualizacion = false;
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al actualizar credenciales',
          text: 'Ocurrió un error al actualizar las credenciales',
        });
      }
    );
  }

  async eliminarServicioDetalleSolicitud(id: number) {
    const confirm = await Swal.fire({
      title: '¿Está seguro de que desea eliminar este servicio?',
      text: '¡Ya no podrá revertir esta acción!',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar servicio',
    });

    if (!confirm.isConfirmed) return;

    this.detalleSolicitudService.eliminarDetalleSolicitud(id).subscribe({
      next: (response) => {
        if (response) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Servicio eliminado',
            text: 'El servicio ha sido eliminado correctamente',
          });

          //this.obtenerDetallesSolicitud();
          const indexElement = this.dataSource.findIndex(
            (e) => e.detalle_solicitud_id === id
          );

          if (indexElement > -1) {
            this.dataSource = [
              ...this.dataSource.filter((e) => e.detalle_solicitud_id !== id),
            ];
          }
        }
      },
      error: (error) => {
        console.error(error);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al eliminar servicio',
          text: 'Ocurrió un error al eliminar el servicio',
        });
      },
    });
  }

  async eliminarServicioDetalleSolicitudEditando(
    element: EdicionServicioModel
  ) {
    if (!element.recienAgregado) {
      element.eliminar = true;
      return;
    }

    this.dataSourceEdicion = [
      ...this.dataSourceEdicion.filter(
        (e) => e.id_tipo_servicio !== element.id_tipo_servicio
      ),
    ];
  }

  revertirEliminacion(element: EdicionServicioModel) {
    element.eliminar = false;
  }
}
